import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import Icon from "hardcover-ui/components/Icon";
import check from "icons/solid/check.svg";
import classNames from "lib/classNames";
import { forwardRef } from "react";

const Checkbox = forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    checked?: boolean;
  }
>(({ className, checked, ...props }, ref) => {
  const finalClassName = classNames(
    "peer h-5 w-5 shrink-0 rounded-md border-2 shadow-sm focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
    checked ? "bg-indigo-500 text-indigo-50" : "bg-gray-900",
    className
  );

  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={finalClassName}
      checked={checked}
      {...props}
    >
      <CheckboxPrimitive.Indicator className="flex items-center justify-center text-current">
        <Icon icon={check} size="sm" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});

Checkbox.displayName = "Checkbox";

export { Checkbox };
